
export const getMin = configKeyName => {
    switch (configKeyName) {
        case 'PAR_ARCH_SETUP':
            return 100

        case 'PAR_ARCH_COMPLETED':
            return 100

        case 'PAR_ARCH_IN_PROGRESS':
            return 100

        default:
            break
    }
}

